import type { MarketCalendarEvent } from './calendarEvents';

export interface CalendarResearchFilters {
    coverage?: string;
    countries?: readonly string[];
    currencies?: readonly string[];
    symbols?: readonly string[];
}
export const matchesCalendarResearchFilters = (
    event: MarketCalendarEvent,
    filters: CalendarResearchFilters,
    hasImpactFilter: boolean,
    hasSourceFilter: boolean,
): boolean => {
    if (
        filters.coverage !== 'all' &&
        !hasImpactFilter &&
        (event.source === 'economic' ? event.impact !== 'high' : !hasSourceFilter)
    ) {
        return false;
    }
    if (
        filters.countries?.length &&
        (event.source !== 'economic' || !filters.countries.includes(event.country ?? ''))
    ) {
        return false;
    }
    if (
        filters.currencies?.length &&
        (event.source !== 'economic' || !filters.currencies.includes(event.currency ?? ''))
    ) {
        return false;
    }
    if (
        filters.symbols?.length &&
        (event.source !== 'dividend' ||
            !filters.symbols.some((symbol) => symbol.toUpperCase() === event.symbol.toUpperCase()))
    ) {
        return false;
    }
    return true;
};
